
import * as handlebars_family from "../handlebars_family.js";
import "../widget/action-menu.js";
const TPL = handlebars_family.addTemplate("feed/action",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span style=\"float:right;\"><icon data-widget=\"widget/action-menu\" data-key=\"feedaction\" data-action-delete=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"delete") : depth0), depth0))
    + "\" data-action-edit=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"edit") : depth0), depth0))
    + "\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_more_vertical",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":197},"end":{"line":1,"column":227}}}))
    + "</icon></span> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if-or").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canDelete") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if-or","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":252}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;